import { AbstractControl } from '@angular/forms';

export class PasswordValidator {
  // Confirm Password validation
  static MatchPassword(AC: AbstractControl) {
    const password = AC.value.password;
    const confirm_password = AC.value.confirm_password;
    if (confirm_password !== '' && password !== '') {
      if (password !== confirm_password) {
        AC.get('confirm_password').setErrors({ MatchPassword: true });
      } else {
        AC.get('confirm_password').setErrors(null);
        return null;
      }
    } else {
      return null;
    }
  }

  static required(control: AbstractControl): { [key: string]: any } | null {
    const value = control.value;
    return !value || value.trim() === '' ? { required: true } : null;
  }
}
